import { skillsetColors, defaultColors } from './colors.js';
export const coreTheme = Object.freeze({
    ...defaultColors,
    secondaryLogo: 'Logo',
    primaryLogo: 'LogoSmall',
    stickyHeaderLogo: 'LogoSmall',
    primaryBoxShadow: '0 4px 13px 0 rgba(73, 172, 233, 0.44)',
    primaryBgPicture: '',
    secondaryBgPicture: '',
    pathwaysBgPicture: ''
});
export const skillsetTheme = Object.freeze({
    ...coreTheme,
    ...skillsetColors
});
//# sourceMappingURL=index.js.map